import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useFeatures } from "flagged";
import { Navigate } from "react-router-dom";
import { ROUTES } from "../constants";
import { actions as breadCrumbActions } from "../components/organisms/BreadCrumb/breadCrumb.reducers";

const { setSelectedTab } = breadCrumbActions;
const { APPLICATIONS, DATAMODELS, USERS, MULESOFT, ORGANIZATIONS } = ROUTES;

const Home = () => {
  const dispatch = useDispatch();
  const {
    showApplications,
    showDataModels,
    showUsers,
    showOrganizations,
    showIntegrations,
  } = useFeatures();

  useEffect(() => {
    dispatch(setSelectedTab(null));
  });

  const getRouteToNavigate = () => {
    if (showApplications) return APPLICATIONS;
    else if (showDataModels) return DATAMODELS;
    else if (showUsers) return USERS;
    else if (showIntegrations) return MULESOFT;
    else if (showOrganizations) return ORGANIZATIONS;
  };

  return <Navigate to={getRouteToNavigate()} replace={true} />;
};

export default Home;
